<div class="relative inset-0 min-w-0 bg-white text-center ring-1 overflow-y-auto max-h-screen">
    <!-- Main -->
    <div class="inline-block px-6 py-2 sm:py-2 text-left print:p-0">

        <!-- Invoice -->
        <div class="w-full p-4 rounded-2xl">

            <div class="flex items-start justify-between">
                <div class="grid grid-cols-1 gap-x-4 gap-y-2">
                    <div class="text-4xl tracking-tight text-secondary">Factura</div>
                    <div *ngIf="(client$ | async) as client" class="pl-10 text-md">
                        <div class="font-medium">{{ client.fiscalName }}</div>
                        <div>{{ client.rut }}</div>
                        <div>{{client.address}}</div>
                        <div>{{ client.phone }}</div>
                        <div class="flex flex-row"><label>OC</label><input class=" w-40 text-lg ml-2 p-1 bg-transparent ring-1 ring-blue-400 rounded-lg mb-1"
                                    [(ngModel)]="orderNumber"
                                    (ngModelChange)="saveDraft()"
                                    placeholder="Orden de compra"></div>
                        <div class="flex flex-row"><label>Correo</label><input class="w-96 text-lg ml-2 p-1 bg-transparent ring-1 ring-blue-400 rounded-lg mb-1"
                                    [(ngModel)]="sendTo"
                                    (ngModelChange)="saveDraft()"
                                    placeholder="Correos"></div>
                    </div>
                </div>

            </div>

            <div class="grid grid-cols-12 gap-x-1 mt-12">
                <!-- Columns -->
                <div class="col-span-7 font-medium text-md text-secondary">SERVICIO</div>
                <div class="font-medium text-md text-right text-secondary">UNITARIO</div>
                <div class="font-medium text-md text-right text-secondary">CANT</div>
                <div class="col-span-2 font-medium text-md text-right text-secondary">TOTAL</div>
                <div class="font-medium text-md text-right text-secondary"></div>

                <!-- Divider -->
                <div class="col-span-12 mt-4 border-gray-300 border"></div>

                <ng-container *ngFor="let billLine of products$ | async; let i = index">

                    <!-- Item -->
                    <div [ngClass]="{'bg-gray-100': i % 2 === 0, 'bg-white': i % 2 !== 0}" class="col-span-7 self-center py-2 px-2">
                        <div class="flex items-center gap-2">
                            <mat-icon class="text-secondary s-20 cursor-help"
                                      [matTooltip]="billLine.serviceDescription"
                                      matTooltipPosition="above">
                                info
                            </mat-icon>
                            <div class="flex-grow">
                                <input class="w-full text-lg font-medium p-1 bg-transparent ring-1 ring-blue-400 rounded-lg"
                                       [value]="billLine.line"
                                       placeholder="Concepto"
                                       (input)="updateConcept($event, billLine)">
                                <input class="w-full text-sm p-1 bg-transparent ring-1 ring-blue-400 rounded-lg "
                                       [value]="billLine.description"
                                       placeholder="Descripción"
                                       (input)="updateDescription($event, billLine)">
                            </div>
                        </div>
                    </div>
                    <div [ngClass]="{'bg-gray-100': i % 2 === 0, 'bg-white': i % 2 !== 0}" class="flex items-center cursor-text border border-transparent
                             hover:shadow-sm hover:border-primary focus-within:bg-white focus-within:shadow-sm focus-within:border-primary">
                        <input class="w-full text-right py-2 font-medium leading-5 bg-transparent ring-1 ring-blue-400 rounded-lg"
                               [value]="billLine.rate"
                               (input)="updateRate($event, billLine)">
                    </div>
                    <div [ngClass]="{'bg-gray-100': i % 2 === 0, 'bg-white': i % 2 !== 0}"
                         class="flex text-bold items-center h-full justify-center py-2">{{ billLine.quantity }}
                    </div>
                    <div [ngClass]="{'bg-gray-100': i % 2 === 0, 'bg-white': i % 2 !== 0}"
                         class="col-span-2 h-full text-bold flex items-center justify-end py-2">{{ formatPrice(billLine.quantity * billLine.rate) }}
                    </div>
                    <div [ngClass]="{'bg-gray-100': i % 2 === 0, 'bg-white': i % 2 !== 0}"
                         class="flex items-center h-full justify-end py-2">
                        <button (click)="removeLine(i)"
                                class="text-red-600 hover:text-red-800 p-1"
                                title="Eliminar línea">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>

                    <!-- Divider -->
                    <div class="col-span-12 border-gray-300 border"></div>
                </ng-container>

                <!-- Botón para agregar nueva línea -->
                <div class="col-span-12 mt-4">
                    <button (click)="addNewLine()"
                            class="flex items-center border-2 border-blue-600 bg-white text-blue-600 py-2 px-4 rounded-md transition-all shadow hover:shadow-lg hover:text-white hover:bg-blue-600">
                        <mat-icon>add</mat-icon>
                        <span class="pl-2">Agregar línea</span>
                    </button>
                </div>

                <!-- Spacer -->
                <div class="col-span-12 mt-16"></div>

                <!-- Subtotal -->
                <div class="col-span-10 self-center font-medium tracking-tight text-secondary uppercase">Subtotal Bruto</div>
                <div class="col-span-2 text-right text-lg">{{formatPrice(getLinesTotal())}}</div>

                <!-- Descuento -->
                <div class="col-span-10 flex items-center gap-4 mt-2">
                    <span class="font-medium tracking-tight text-secondary uppercase">Descuento</span>
                    <div class="flex items-center gap-2">
                        <input class="w-24 text-right p-1 bg-transparent ring-1 ring-blue-400 rounded-lg"
                               [(ngModel)]="discount"
                               (ngModelChange)="saveDraft()"
                               type="number"
                               placeholder="0">
                        <select class="p-1 bg-transparent ring-1 ring-blue-400 rounded-lg"
                                [(ngModel)]="discountType"
                                (ngModelChange)="saveDraft()">
                            <option value="percentage">%</option>
                            <option value="amount">$</option>
                        </select>
                    </div>
                </div>
                <div class="col-span-2 text-right text-lg text-red-600">- {{formatPrice(getDiscountAmount())}}</div>

                <!-- Divider -->
                <div class="col-span-12 my-3 border-b"></div>

                <!-- Subtotal Neto -->
                <div class="col-span-10 self-center font-medium tracking-tight text-secondary uppercase">Subtotal Neto</div>
                <div class="col-span-2 text-right text-lg">{{formatPrice(getSubtotal())}}</div>

                <!-- Divider -->
                <div class="col-span-12 my-3 border-b"></div>

                <!-- Tax -->
                <div class="col-span-10 self-center font-medium tracking-tight text-secondary uppercase">IVA (22%)</div>
                <div class="col-span-2 text-right text-lg">{{formatPrice(getSubtotal()*0.22)}}</div>

                <!-- Divider -->
                <div class="col-span-12 my-3 border-b"></div>

                <!-- Total -->
                <div class="col-span-10 self-center text-2xl font-medium tracking-tight text-secondary uppercase">Total</div>
                <div class="col-span-2 text-right text-2xl font-medium">{{formatPrice(getSubtotal()*1.22)}}</div>


            </div>
            <div class="flex flex-row justify-between mx-10">

                <div class=" mt-10">
                    <button  (click)="noBillProjects()"
                             class="flex items-center border-2 border-slate-600 bg-white py-2 px-4 rounded-md transition-all shadow-lg hover:shadow-2xl text-slate-600 hover:text-white hover:bg-slate-600 hover:border-slate-800 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
                        <mat-icon>check</mat-icon>
                        <span class="text-center pl-2 ">Marcar NF</span>
                    </button>
                </div>

                <div class=" mt-10">
                    <button  (click)="billProjects()"
                             class="flex items-center border-2 border-slate-600 bg-white py-2 px-4 rounded-md transition-all shadow-lg hover:shadow-2xl text-slate-600 hover:text-white hover:bg-slate-600 hover:border-slate-800 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
                        <mat-icon>check</mat-icon>
                        <span class="text-center pl-2 ">Confirmar</span>
                    </button>
                </div>

                <div class=" mt-10">
                    <button  (click)="cancel()"
                             class="flex items-center border-2 bg-white text-red-600 border-red-600 py-2 px-4 rounded-md transition-all shadow-lg hover:shadow-2xl hover:text-white hover:bg-red-600 hover:border-red-600 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none">
                        <mat-icon>cancel</mat-icon>
                        <span class="text-center pl-2 ">Cancelar</span>
                    </button>
                </div>
            </div>

        </div>

    </div>

</div>
